import { useEffect, useMemo, useRef, useState } from "react";
import { ChangeAlertCallbackType } from "../../../Root";
import { AdminService } from "../../../../services/AdminService";
import { FormGroup, FormControlLabel, Switch } from "@mui/material";

export const useCRMAnalist = (changeAlert: ChangeAlertCallbackType, crmType: string) => {
    const adminService = useRef<AdminService>();
    const [configAgent, setConfigAgent] = useState([]);
    const [expanded, setExpanded] = useState(false);
    const [maxAssign, setMaxAssign] = useState(false);
    const [loading, setLoading] = useState(true);
    const [role, setRole] = useState('');


    const updateMaxAssign = async (max, uuid) => {
        setLoading(true);
        let data = {
            maxAssign: max ? false : true,
            uuid: uuid,
            prop: "maxAssignedCrm",
        };

        const response = await adminService.current.maxAssignedCrm(data);
        if (response["data"]?.response === "OK") {
            await findAgentsFilter();
            changeAlert(true, 'success', 'Permiso de asignación actualizado con éxito.');
            setLoading(false);
        } else {
            setLoading(false);
            changeAlert(true, "error", response["message"] || response["data"]['message'] || "Error al consultar servicio");
        };
        setLoading(false);
    };

    const findAgentsFilter = async () => {
        setLoading(true);
        setLoading(true);
        let role = ''
        switch (crmType) {
            case 'afb':
                role = 'inext-role-afb-kam'
                break;
        }

        const response = await adminService.current.agentCrmList(role);
        if (response["data"]?.response === "OK") {
            setConfigAgent(JSON.parse(JSON.stringify(response.data.content)));
            setLoading(false);
        } else {
            setLoading(false);
            changeAlert(true, "error", response["message"] || response["data"]['message'] || "Error al consultar servicio");
        };
        setLoading(false);
    };

    const changeExpanded = async (e, flag) => {
        flag ? await findAgentsFilter() : setConfigAgent([]);
        setExpanded(flag);
    };


    useEffect(() => {
        setMaxAssign(false);
        switch (crmType) {
            case 'afb':
                setRole('Listado de Analistas');
                break;
        }

        adminService.current = new AdminService(changeAlert);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const calculateColumns = useMemo(() => {
        const columns = [
            {   selector: (row) => row.name, name: "Nombre de agente", width: "22%", wrap: true, sortable: true },
            {   selector: (row) => row.email, name: "Email", width: "22%", wrap: true, sortable: true },
            {   selector: (row) => row.leadCrmAssigned || 0, name: "Empresas", width: "9%", wrap: true, sortable: true, center: true, style: {backgroundColor: '#d2dfeb', borderRadius: '15px', border: 'white solid 10px'}},
            {   selector: (row) => row.contactCrmAssigned || 0, name: "Contactos", width: "9%", wrap: true, sortable: true, center: true, style: {backgroundColor: '#d2dfeb', borderRadius: '15px', border: 'white solid 10px'}},
            {   selector: (row) => ((row['leadCrmAssigned'] || 0) + (row['contactCrmAssigned'] || 0)) || 0, name: "Total", width: "9%", wrap: true, sortable: true, center: true, style: {backgroundColor: '#b7f0a3', borderRadius: '15px', border: 'white solid 10px'}},
            {   cell: (row) => {
                    return <FormGroup>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={row.maxAssignedCrm ? true : false}
                                        onChange={updateMaxAssign.bind(this, row.maxAssignedCrm, row.uuid)}
                                    />
                                }
                                label={row.maxAssignedCrm ? 'Activo' : 'Inactivo'}
                            />

                    </FormGroup>
                }, name: 'Asignar', width: '15%', sortable: true, wrap: true, center: true, style: {backgroundColor: '#fae2d7', borderRadius: '15px', border: 'white solid 10px'}
            },
        ];

        return columns;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [configAgent, maxAssign]);

    return {
        loading,
        columns: calculateColumns,
        configAgent,
        expanded,
        role,
        changeExpanded,
    };
};
